import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { CACHE_KEY_FACILITY_BY_ZIPCODE, CACHE_KEY_PHARMAKON_FACILITY_BY_ACCOUNT } from 'src/app/hooks/data/_keys';
import { useBffClient } from 'src/app/hooks/data/useBffClient';
import type { ReactQueryOptions } from 'src/app/types';
import type { Facility } from 'src/app/types/facility';

export const useFacilityByAccountId = (
  accountId: number,
  options?: Partial<ReactQueryOptions>
): UseQueryResult<Facility, AxiosError> => {
  const authClient = useBffClient();

  return useQuery(
    [CACHE_KEY_PHARMAKON_FACILITY_BY_ACCOUNT, accountId],
    () => authClient.get(`/accounts/${accountId}/facility`).then((resp: { data: Facility }) => resp.data),
    {
      enabled: !!accountId && (options?.enabled === undefined || !!options?.enabled),
      ...(options?.refetchOnWindowFocus !== undefined && { refetchOnWindowFocus: options?.refetchOnWindowFocus }),
    }
  );
};

export const useFacilityByZipCode = (
  zipCode: string,
  options?: Partial<ReactQueryOptions>
): UseQueryResult<Facility, AxiosError> => {
  const authClient = useBffClient();
  return useQuery(
    [CACHE_KEY_FACILITY_BY_ZIPCODE, zipCode],
    () =>
      authClient.get(`facility/facility_by_zip_code/${zipCode}`).then((resp: { data: Facility }) => {
        return resp.data;
      }),
    {
      enabled: !!zipCode && (options?.enabled === undefined || !!options?.enabled),
      ...(options?.refetchOnWindowFocus !== undefined && { refetchOnWindowFocus: options?.refetchOnWindowFocus }),
    }
  );
};
